import {TimeKeepingEN} from "./timekeeping/en";
import {PersonnelEN} from "./personnel/en";
import {ApplicationEN} from "./application/en";
import {OkrEN} from "./okr/en";

export const SettingEN = {
    "generalSettings": "General Settings",
    "setting": "Setting",
    ...PersonnelEN,
    ...ApplicationEN,
    ...TimeKeepingEN,
    ...OkrEN

}